{
  "REPORT": {
    "HEADER": "Vestlused",
    "LOADING_CHART": "Laaditakse diagrammi andmeid...",
    "NO_ENOUGH_DATA": "Me pole saanud piisavalt andmepunkte aruande genereerimiseks, palun proovige hiljem uuesti.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Laadi alla vestluste aruanded",
    "DATA_FETCHING_FAILED": "Andmete toomine ebaõnnestus, palun proovi hiljem uuesti.",
    "SUMMARY_FETCHING_FAILED": "Kokkuvõtte toomine ebaõnnestus, palun proovi hiljem uuesti.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Vestlused",
        "DESC": "(Kokku)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Vastuvõetud sõnumid",
        "DESC": "(Kokku)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Saadetud sõnumid",
        "DESC": "( Kogus )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Esimene vastuse aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutamiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Esimene vastuse aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lahendamise aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutamiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Lahendamise aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kokku )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kokku )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Üleandmiste arv",
        "DESC": "( Kokku )"
      },
      "REPLY_TIME": {
        "NAME": "Kliendi ooteaeg",
        "TOOLTIP_TEXT": "Ooteaeg on {metricValue} (põhineb {conversationCount} vastusel)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Viimased 7 päeva",
      "LAST_14_DAYS": "Viimased 14 päeva",
      "LAST_30_DAYS": "Viimased 30 päeva",
      "THIS_MONTH": "Käesolev kuu",
      "LAST_MONTH": "Eelmine kuu",
      "LAST_3_MONTHS": "Viimased 3 kuud",
      "LAST_6_MONTHS": "Viimased 6 kuud",
      "LAST_YEAR": "Eelmine aasta",
      "CUSTOM_DATE_RANGE": "Kohandatud kuupäevavahemik"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Rakenda",
      "PLACEHOLDER": "Vali kuupäevavahemik"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupeeri",
    "DURATION_FILTER_LABEL": "Kestus",
    "GROUPING_OPTIONS": {
      "DAY": "Päev",
      "WEEK": "Nädal",
      "MONTH": "Kuu",
      "YEAR": "Aasta"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Päev"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Päev"
      },
      {
        "id": 2,
        "groupBy": "Nädal"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Päev"
      },
      {
        "id": 2,
        "groupBy": "Nädal"
      },
      {
        "id": 3,
        "groupBy": "Kuu"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Nädal"
      },
      {
        "id": 3,
        "groupBy": "Kuu"
      },
      {
        "id": 4,
        "groupBy": "Aasta"
      }
    ],
    "BUSINESS_HOURS": "Tööaeg",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Tühjenda filter",
      "EMPTY_LIST": "Tulemusi ei leitud"
    },
    "PAGINATION": {
      "RESULTS": "Kuvatakse {start} kuni {end} {total} tulemusest",
      "PER_PAGE_TEMPLATE": "{size} / lehekülg"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agentide ülevaade",
    "DESCRIPTION": "Jälgi agentide sooritust lihtsalt oluliste mõõdikutega nagu vestlused, vastamisajad, lahendamisajad ja lahendatud juhtumid. Klõpsa agendi nimele, et rohkem teada saada.",
    "LOADING_CHART": "Diagrammi andmete laadimine...",
    "NO_ENOUGH_DATA": "Meil pole piisavalt andmepunkte aruande genereerimiseks, palun proovige hiljem uuesti.",
    "DOWNLOAD_AGENT_REPORTS": "Laadi alla agendi aruanded",
    "FILTER_DROPDOWN_LABEL": "Vali agent",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Otsi agente"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Vestlused",
        "DESC": "( Kogus )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Sissetulevad sõnumid",
        "DESC": "( Kogus )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Väljaminevad sõnumid",
        "DESC": "( Kogus )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Esimene vastuse aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutuste tegemiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Esimese vastuse aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lahendamise aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutuste tegemiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Lahendamise aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kokku )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimased 7 päeva"
      },
      {
        "id": 1,
        "name": "Viimased 30 päeva"
      },
      {
        "id": 2,
        "name": "Viimased 3 kuud"
      },
      {
        "id": 3,
        "name": "Viimased 6 kuud"
      },
      {
        "id": 4,
        "name": "Eelmine aasta"
      },
      {
        "id": 5,
        "name": "Kohandatud kuupäevavahemik"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Rakenda",
      "PLACEHOLDER": "Vali kuupäevavahemik"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Siltide ülevaade",
    "DESCRIPTION": "Jälgi sildi tulemuslikkust peamiste mõõdikute abil, sealhulgas vestlused, vastamisajad, lahendamise ajad ja lahendatud juhtumid. Täpsemate teadmiste saamiseks klõpsa sildi nimele.",
    "LOADING_CHART": "Diagrammi andmete laadimine...",
    "NO_ENOUGH_DATA": "Meil ei ole piisavalt andmepunkte aruande genereerimiseks, palun proovige hiljem uuesti.",
    "DOWNLOAD_LABEL_REPORTS": "Laadi alla sildiaruanded",
    "FILTER_DROPDOWN_LABEL": "Vali silt",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Otsi silte"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Vestlused",
        "DESC": "(Kokku)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Sissetulevad sõnumid",
        "DESC": "( Kogus )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Väljaminevad sõnumid",
        "DESC": "( Kogus )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Esimene vastuse aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutuste tegemiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Esimese vastuse aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lahendamise aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutuste tegemiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Lahendamise aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kogus )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimased 7 päeva"
      },
      {
        "id": 1,
        "name": "Viimased 30 päeva"
      },
      {
        "id": 2,
        "name": "Viimased 3 kuud"
      },
      {
        "id": 3,
        "name": "Viimased 6 kuud"
      },
      {
        "id": 4,
        "name": "Eelmine aasta"
      },
      {
        "id": 5,
        "name": "Kohandatud kuupäevavahemik"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Rakenda",
      "PLACEHOLDER": "Vali kuupäevavahemik"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Postkasti ülevaade",
    "DESCRIPTION": "Vaata kiiresti oma postkasti tulemuslikkust võtmemõõdikute abil nagu vestlused, reageerimisajad, lahendamisajad ja lahendatud juhtumid – kõik ühes kohas. Klõpsa postkasti nimele, et näha rohkem üksikasju.",
    "LOADING_CHART": "Diagrammi andmete laadimine...",
    "NO_ENOUGH_DATA": "Meil pole piisavalt andmepunkte aruande genereerimiseks, palun proovige hiljem uuesti.",
    "DOWNLOAD_INBOX_REPORTS": "Laadi alla postkasti aruanded",
    "FILTER_DROPDOWN_LABEL": "Vali postkast",
    "ALL_INBOXES": "Kõik postkastid",
    "SEARCH_INBOX": "Otsi postkastist",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Otsi postkaste"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Vestlused",
        "DESC": "( Kokku )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Sissetulevad sõnumid",
        "DESC": "( Kogus )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Väljaminevad sõnumid",
        "DESC": "( Kogus )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Esimene vastuse aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutamiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Esimene vastuse aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lahendamise aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutamiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Lahendamise aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kogus )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimased 7 päeva"
      },
      {
        "id": 1,
        "name": "Viimased 30 päeva"
      },
      {
        "id": 2,
        "name": "Viimased 3 kuud"
      },
      {
        "id": 3,
        "name": "Viimased 6 kuud"
      },
      {
        "id": 4,
        "name": "Eelmine aasta"
      },
      {
        "id": 5,
        "name": "Kohandatud kuupäevavahemik"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Rakenda",
      "PLACEHOLDER": "Vali kuupäevavahemik"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Meeskonna ülevaade",
    "DESCRIPTION": "Saate ülevaate oma meeskonna tulemuslikkusest oluliste mõõdikutega, sealhulgas vestlused, reageerimisajad, lahendamise ajad ja lahendatud juhtumid. Lisateabe saamiseks klõpsake meeskonna nime.",
    "LOADING_CHART": "Diagrammi andmete laadimine...",
    "NO_ENOUGH_DATA": "Meil ei ole piisavalt andmepunkte aruande koostamiseks, palun proovige hiljem uuesti.",
    "DOWNLOAD_TEAM_REPORTS": "Laadi alla meeskonna aruanded",
    "FILTER_DROPDOWN_LABEL": "Vali meeskond",
    "FILTERS": {
      "ADD_FILTER": "Lisa filter",
      "CLEAR_ALL": "Tühjenda kõik",
      "NO_FILTER": "Filtreid pole saadaval",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Otsi meeskondi"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Vestlused",
        "DESC": "( Kogus )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Sissetulevad sõnumid",
        "DESC": "( Kogus )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Väljaminevad sõnumid",
        "DESC": "( Kogus )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Esimene vastuse aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Arvutamiseks kasutatud vestluste koguarv:",
        "TOOLTIP_TEXT": "Esimene vastuse aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lahendamise aeg",
        "DESC": "( Keskmine )",
        "INFO_TEXT": "Kokku vestluste arv arvutamiseks:",
        "TOOLTIP_TEXT": "Lahendamise aeg on {metricValue} (põhineb {conversationCount} vestlusel)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lahenduste arv",
        "DESC": "( Kogus )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Viimased 7 päeva"
      },
      {
        "id": 1,
        "name": "Viimased 30 päeva"
      },
      {
        "id": 2,
        "name": "Viimased 3 kuud"
      },
      {
        "id": 3,
        "name": "Viimased 6 kuud"
      },
      {
        "id": 4,
        "name": "Eelmine aasta"
      },
      {
        "id": 5,
        "name": "Kohandatud kuupäevavahemik"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Rakenda",
      "PLACEHOLDER": "Vali kuupäevavahemik"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT aruanded",
    "NO_RECORDS": "Vastuseid pole veel",
    "NO_RECORDS_DESCRIPTION": "Kliendirahulolu küsitluse vastused kuvatakse siin, kui kliendid hakkavad tagasisidet andma.",
    "DOWNLOAD": "Laadi alla CSAT aruanded",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "Lisa filter",
      "CLEAR_ALL": "Tühjenda kõik",
      "NO_FILTER": "Filtreid pole saadaval",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Otsi agente",
        "INBOXES": "Otsi postkaste",
        "TEAMS": "Otsi meeskondi",
        "RATINGS": "Otsi hinnanguid"
      },
      "AGENTS": {
        "LABEL": "Agent"
      },
      "INBOXES": {
        "LABEL": "Sissetulek"
      },
      "TEAMS": {
        "LABEL": "Meeskond"
      },
      "RATINGS": {
        "LABEL": "Hinnang"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Agent",
        "RATING": "Hinnang",
        "FEEDBACK_TEXT": "Tagasiside kommentaar",
        "CONVERSATION": "Vestlus",
        "CUSTOMER": "Klient",
        "RESPONSE": "Vastus",
        "HANDLED_BY": "Käsitlenud"
      },
      "UNKNOWN_CUSTOMER": "Tundmatu klient"
    },
    "NO_AGENT": "Määramata agent",
    "NO_FEEDBACK": "Tagasisidet ei ole antud",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Vastuste koguarv",
        "TOOLTIP": "Kogutud vastuste koguarv"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Rahulolu skoor",
        "TOOLTIP": "Positiivsete vastuste koguarv / Vastuste koguarv * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Vastuste määr",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      },
      "RATING_DISTRIBUTION": "Hinnangute jaotus"
    },
    "REVIEW_NOTES": {
      "TITLE": "Ülevaate märkmed",
      "PLACEHOLDER": "Lisa selle hinnangu kohta ülevaate märkmeid...",
      "SAVE": "Salvesta",
      "CANCEL": "Tühista",
      "SAVING": "Salvestamine...",
      "SAVED": "Märkmed salvestatud edukalt",
      "SAVE_ERROR": "Märkmete salvestamine ebaõnnestus",
      "UPDATED_BY": "Uuendas {name} {time}",
      "UPDATED_BY_LABEL": "Uuendas",
      "PAYWALL": {
        "TITLE": "Uuenda, et lisada ülevaate märkmeid",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Lisa igale CSAT vastusele sisekontekst arvustuste märkmetega. Kogu teavet tegeliku olukorra kohta, avasta mustreid kiiremini ja tee paremaid otsuseid oma tagasiside põhjal.",
        "UPGRADE_NOW": "Uuenda kohe",
        "CANCEL_ANYTIME": "Saad oma plaani igal ajal muuta või tühistada"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Vestluste arv",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Vastuste koguarv",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Lahendamise määr",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Üleandmise määr",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Ülevaade",
    "LIVE": "Otseülekanne",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Avatud vestlused",
      "LOADING_MESSAGE": "Vestluse mõõdikute laadimine...",
      "OPEN": "Avatud",
      "UNATTENDED": "Jäetud tähelepanuta",
      "UNASSIGNED": "Määramata",
      "PENDING": "Ootel"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Vestluste liiklus",
      "NO_CONVERSATIONS": "Vestlusi pole",
      "CONVERSATION": "{count} vestlus",
      "CONVERSATIONS": "{count} vestlust",
      "DOWNLOAD_REPORT": "Laadi aruanne alla"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Lahendused",
      "NO_CONVERSATIONS": "Vestlusi pole",
      "CONVERSATION": "{count} vestlus",
      "CONVERSATIONS": "{count} vestlust",
      "DOWNLOAD_REPORT": "Laadi aruanne alla"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Agentide vestlused",
      "LOADING_MESSAGE": "Agendi mõõdikute laadimine...",
      "NO_AGENTS": "Agentide vestlusi pole",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Ava",
        "UNATTENDED": "Jäetud tähelepanuta",
        "STATUS": "Staatus"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Kõik meeskonnad",
      "HEADER": "Vestlused meeskondade kaupa",
      "LOADING_MESSAGE": "Meeskonna mõõdikute laadimine...",
      "NO_TEAMS": "Andmeid pole saadaval",
      "TABLE_HEADER": {
        "TEAM": "Meeskond",
        "OPEN": "Avatud",
        "UNATTENDED": "Jäetud tähelepanuta",
        "STATUS": "Staatus"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agendi olek",
      "ONLINE": "Veebis",
      "BUSY": "Hõivatud",
      "OFFLINE": "Võrgust väljas"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Pühapäev",
    "MONDAY": "Monday",
    "TUESDAY": "Teisipäev",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Neljapäev",
    "FRIDAY": "Reede",
    "SATURDAY": "Laupäev"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA aruanded",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Laaditakse SLA andmeid...",
    "DOWNLOAD_SLA_REPORTS": "Laadi alla SLA aruanded",
    "DOWNLOAD_FAILED": "SLA aruannete allalaadimine ebaõnnestus",
    "DROPDOWN": {
      "ADD_FIlTER": "Lisa filter",
      "CLEAR_ALL": "Tühjenda kõik",
      "CLEAR_FILTER": "Tühjenda filter",
      "EMPTY_LIST": "Tulemusi ei leitud",
      "NO_FILTER": "Filtreid pole saadaval",
      "SEARCH": "Otsi filtrit",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA nimi",
        "AGENTS": "Agendi nimi",
        "INBOXES": "Postkasti nimi",
        "LABELS": "Sildi nimi",
        "TEAMS": "Meeskonna nimi"
      },
      "SLA": "SLA poliitika",
      "INBOXES": "Postkast",
      "AGENTS": "Agent",
      "LABELS": "Silt",
      "TEAMS": "Meeskond"
    },
    "WITH": "koos",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Täitumismäär",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Mittejärgimiste arv",
        "TOOLTIP": "Kokku SLA mittejärgimised kindlal perioodil"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Vestluste arv",
        "TOOLTIP": "Vestluste koguarv, millel on SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Poliitika",
        "CONVERSATION": "Vestlus",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Vaata üksikasju"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Postkast",
    "AGENT": "Agent",
    "TEAM": "Meeskond",
    "LABEL": "Silt",
    "AVG_RESOLUTION_TIME": "Keskmine lahendusaeg",
    "AVG_FIRST_RESPONSE_TIME": "Keskmine esimene vastuse aeg",
    "AVG_REPLY_TIME": "Keskmine kliendi ooteaeg",
    "RESOLUTION_COUNT": "Lahenduste arv",
    "CONVERSATIONS": "Vestluste arv"
  }
}
